export interface ReplenishmentPlanState {
  isLoadingPlan: boolean
  isSearchingProducts: boolean
  products: Product[]
  planProducts: Product[]
  forecastItems: PlanItem<ForecastItem>
  plannedItems: PlanItem<PlannedItem>
  shipmentItems: PlanItem<ShipmentItem[]>
  submittedItems: PlanItem<SubmittedItem>
  replaceProductId: number | null
  species: Species[]
  planTableFilter: PlanTableFilter
}

export interface PlanTableFilter {
  displayValueMode: DisplayValueMode
  displayProductsMode: DisplayProductsMode
  sort: Sort
  selectedSpecies: Species[]
  search: string
}

export enum DisplayValueMode {
  amount,
  cost,
}

export enum DisplayProductsMode {
  categories,
  plainList,
}

export enum SortBy {
  cost,
  unitPrice,
  alphabetically,
}

export interface Sort {
  sortBy: SortBy
  asc: boolean
}

// { productId, { month: <T> } }
export type PlanItem<T> = Record<number, Record<string, T> | null>

export interface Product {
  id: number
  name: string
  code: string
  unit: string | null
  photo: string | null
  price: number
  category: Category | null
  group: Group | null
  speciesIds: number[]
  isInPlan: boolean
  erpCatalogName: string
  caseQuantity?: number | null
  palletQuantity?: number | null
  unavailable?: boolean
  salableProductId: number | null
}

// Pest/Animal species tag on a product. group is null when Unclassified.
export interface Species {
  sanaId: number
  name: string
  group: string | null
}

export interface Category {
  id: number
  name: string
  code: string
}

export interface Group {
  id: number
  name: string
  code: string
}

export interface PlannedItem {
  amount: number
}

export interface ForecastItem {
  amountSuggested: number
  amountMaxSuggested: number
  amountMinSuggested: number
}

export interface ShipmentItem {
  amount: number
  price: number
}

export interface SubmittedItem {
  amount: number
}
